import { Link } from 'react-router-dom';

// third-party
import { FormattedMessage } from 'react-intl';

// project import
import useAuth from 'hooks/useAuth';

// material-ui
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Box, Button, Grid, Stack, Typography } from '@mui/material';

// assets
import error500 from 'assets/images/maintenance/Error500.png';

// ==============================|| ERROR 500 - MAIN ||============================== //

function Error500() {
  const theme = useTheme();
  const { user } = useAuth();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Grid container direction="column" alignItems="center" justifyContent="center" sx={{ minHeight: '100vh' }}>
        <Grid item xs={12}>
          <Box sx={{ width: { xs: 350, sm: 396 } }}>
            <img src={error500} alt="mantis" style={{ height: '100%', width: '100%' }} />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Stack justifyContent="center" alignItems="center">
            <Typography align="center" variant={matchDownSM ? 'h2' : 'h1'}>
              <FormattedMessage id="500.internal-server-error" />
            </Typography>
            <Typography color="textSecondary" variant="body2" align="center" sx={{ width: { xs: '73%', sm: '70%' }, mt: 1 }}>
              <FormattedMessage id="500.server-error-we-are-fixing-problem" />
            </Typography>
            <Button component={Link} to={user.defaultPath} variant="contained" sx={{ textTransform: 'none', mt: 4 }}>
              <FormattedMessage id="500.go-to-homepage" />
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}

export default Error500;
